export default __webpack_public_path__ + "static/media/hero.5ccf24d0.png";